import { render, staticRenderFns } from "./MenuListComponent.vue?vue&type=template&id=ce4cf130&"
import script from "./MenuListComponent.vue?vue&type=script&lang=js&"
export * from "./MenuListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports